module.exports = __webpack_public_path__ + "img/icon-lordsmobile.744d592.png";